import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { AppInfoService } from 'core/app-info/app-info.service';
import { DashboardService } from '../services/dashboard.service';
import { syncStatus } from './entities/sync-status-values';
import { syncType } from './entities/sync-types-values';

@Component({
  selector: 'app-sync-history',
  templateUrl: './sync-history.component.html',
  styleUrls: ['./sync-history.component.scss'],
  standalone: false
})
export class SyncHistoryComponent implements OnInit {
  appStrings;
  syncListResult = {
    countSyncs: '',
    syncs: []
  };
  pageSize = 50;
  currentPage = 0;
  displayedColumns: string[] = [
    'icon',
    'type',
    'status',
    'startDate',
    'syncDate'
  ];
  syncTypeValues = syncType;
  syncStatusValues = syncStatus;
  dateTimeFormat: any;

  constructor(
    private appInfoService: AppInfoService,
    private dashboardService: DashboardService
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.dateTimeFormat = this.appInfoService.dateTimeFormat;
    this.getSyncList(0);
  }

  loadPage(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.getSyncList(event.pageIndex);
  }

  getSyncList(pageIndex) {
    const offsetPage = pageIndex * this.pageSize;
    this.dashboardService.getSyncHistory(pageIndex, offsetPage, syncsList => {
      this.syncListResult.countSyncs = syncsList.count;
      this.syncListResult.syncs = syncsList.syncHistoryList;
    });
  }

}
